let File = require("../lib/File");

class PlotCSVDownload extends React.Component {
  download() {
    let {
      data,
      getX,
      getY,
      labelX,
      labelY,
      formatX,
      useXFormat
    } = this.props;

    let row = (d, i) => {
      let x = getX(d, i);
      let y = getY(d);

      if (useXFormat) {
        x = formatX(x, i);
      }
      else if (x.toJSON) {
        x = x.toJSON();
      }

      return [x, y].join(",");
    };

    let text = [labelX + "," + labelY].concat(data.map(row)).join("\n");

    File.download("data.csv", "text/csv", text);
  };

  render () {
    let { width } = this.props;

    return (
      <image
        className="mc-plot-download"
        x={width - 20}
        y="3"
        width="16"
        height="16"
        xlinkHref="./img/mc/chart.download.svg"
        onClick={this.download.bind(this)}
        data-tooltip="CSV"/>
    );
  }
};

PlotCSVDownload.defaultProps = {
  labelX: "x",
  labelY: "y",
  useXFormat: false
};

module.exports = PlotCSVDownload;
